<script type="text/ecmascript-6">

    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    import {mapGetters} from 'vuex';

    export default {
        name: 'newRelease',

        props: {
            data:{
                type:Object,
            }
        },

        components: {
            swiper,
            swiperSlide,
        },

        /**
         * The component's data.
         */
        data: () => ({
            count: 0,
            loading: false,
            swiperOption: {
                slidesPerView: 8,
                slidesPerColumn: 1,
                spaceBetween: 15,
                slidesPerGroup: 4,
                // loop: true,
                speed: 500,
                navigation: {
                    nextEl: '',
                    prevEl: '',
                },
                breakpoints: {
                    2900: {
                        slidesPerView: 8,
                    },
                    1900: {
                        slidesPerView: 8,
                    },
                    1800: {
                        slidesPerView: 8,
                    },
                    1400: {
                        slidesPerView: 8,
                    },
                    1124: {
                        slidesPerView: 6,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                    992: {
                        slidesPerView: 6,
                    },
                    834: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    },
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        slidesPerGroup: 1,
                    },
                    375: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        slidesPerGroup: 1,
                    }
                },
            },
            show: false,
        }),


        /**
         * Created the component.
         */
        created() {
            this.swiperOption.navigation.nextEl = '.swiper-button-album-next'+this.data.id+'-'+this.data.order;
            this.swiperOption.navigation.prevEl = '.swiper-button-album-prev'+this.data.id+'-'+this.data.order;
        },

        mounted(){
            let _this = this;
            this.$nextTick(() => {
                _this.swiper.on('slideChange', function () {
                    if(!_this.isBeginning){
                        $('.swiper-button-album-prev'+_this.data.id+'-'+_this.data.order).removeClass('d-none');
                    }else{
                        $('.swiper-button-album-prev'+_this.data.id+'-'+_this.data.order).addClass('d-none');
                    }
                    if(!_this.isEnd){
                        $('.swiper-button-album-next'+_this.data.id+'-'+_this.data.order).removeClass('d-none');
                    }else{
                        $('.swiper-button-album-next'+_this.data.id+'-'+_this.data.order).addClass('d-none');
                    }
                });
            });
        },


        computed: {
            swiper() {
                return this.$refs['albumSwiper'+this.data.id+'-'+this.data.order].swiper
            },
            ...mapGetters({
                isAuthenticated: 'isAuthenticated',
                user : 'getProfile',
            }),
            isBeginning() {
                return this.swiper.isBeginning;
            },
            isEnd() {
                return this.swiper.isEnd;
            },

        },

        methods: {

            /**
             *  Buy the album.
             */
            buyAlbum(uuid) {
                this.$store.dispatch('setAlbumUUid', uuid).then(() => {
                    this.$nextTick(() => {
                        $('#buyAlbumModal').modal('show');
                    });
                });
            },

        }

    }
</script>

<template>
    <div class="ms_radio_wrapper" v-show="data.data.length > 0">
        <div class="ms_heading">
            <h1>{{data.title}}</h1>
            <!-- <span class="veiw_all">
                <router-link to="/new-releases">view more</router-link>
            </span> -->
        </div>

        <div class="row" v-show="loading">
            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>

            <div class="col-md-2" style="display: inline-block">
                <div class="load-music-box"></div>
            </div>
        </div>

        <div v-show="!loading" class="ms_radio_slider swiper-container">
            <swiper :options="swiperOption" :ref="'albumSwiper'+data.id+'-'+data.order">
                <!-- slides -->
                <template v-for="(album,key) in data.data">
                    <swiper-slide :key="key">

                        <div class="ms_rcnt_box">
                            <div class="ms_rcnt_box_img">
                                <img :src="album.image" alt="" onError="this.onerror=null;this.src='/images/album/Album.png';">
                                <!-- <img v-lazy="album.image" alt=""> -->
                                <div class="ms_main_overlay">
                                    <router-link tag="a" :to="{ name: 'Album', params: { uuid: album.uuid }}" :title="album.name_mm">
                                        <div class="ms_box_overlay"></div>
                                        <div class="ms_play_icon">
                                            <a href="javascript:;" @click.prevent="playAllSong(album.uuid)">
                                                <img src="/images/svg/play2.svg" alt="">
                                            </a>
                                        </div>
                                    </router-link>

                                    <div class="ms_more_icon" data-toggle="popup">
                                        <img src="/images/svg/more.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <ul class="more_option">
                                <template v-if="isAuthenticated">
                                    <li><a href="#" @click.prevent="saveAlbum(album.uuid)"><span class="opt_icon"><span class="fa fa-plus"></span></span>Add To Playlist </a></li>
                                    <li><a href="#" @click.prevent="syncAlbumFavourite(album.uuid)"><span class="opt_icon"><span class="icon icon_fav"></span></span>Add To Favourites </a></li>
                                    <li v-if="album.is_store && album.price > 0 && !album.is_bought">
                                        <a href="#" @click="buyAlbum(album.uuid)"><span class="opt_icon"><span class="fa fa-shopping-cart"></span></span>{{ album.price.toLocaleString() }} Kyat</a>
                                    </li>
                                </template>

                                <template v-else>
                                    <li><a href="#" data-toggle="modal" data-target="#loginModal"><span class="opt_icon"><span class="fa fa-plus"></span></span>Add To Playlist </a></li>
                                    <li><a href="#" data-toggle="modal" data-target="#loginModal"><span class="opt_icon"><span class="icon icon_fav"></span></span>Add To Favourites </a></li>
                                    <li v-if="album.is_store && album.price > 0">
                                        <a href="#" data-toggle="modal" data-target="#loginModal"><span class="opt_icon"><span class="fa fa-shopping-cart"></span></span>{{ album.price.toLocaleString() }} Kyat</a>
                                    </li>
                                </template>

                                <li><a :href="shareFacebookLink(album.image,'albums',album.name,album.id,album.uuid)" target="_blank"><span class="opt_icon"><span class="fa fa-facebook-official"></span></span>Share to facebook</a></li>
                                <li><a :href="shareTwitterLink(album.image,'albums',album.name,album.id,album.uuid)" target="_blank"><span class="opt_icon"><span class="fa fa-twitter-square"></span></span>Share to twitter</a></li>
                                <li><a href="#" @click.prevent="copyText('album/'+album.uuid)"><span class="opt_icon"><span class="fa fa-copy"></span></span>Copy link</a></li>
                            </ul>
                            <div class="ms_rcnt_box_text">
                                <h3><router-link tag="a" :to="{ name: 'Album', params: { uuid: album.uuid }}">{{ album.name}}</router-link></h3>
                                <p>
                                    {{album.description}}
                                    <!-- <template v-if="album.artists.length > 3">
                                        <a href="javascript:;">Various Artists</a>
                                    </template>

                                    <template v-else>
                                        <template v-for="(artist, index1) in album.artists">
                                            <router-link :to="{ name : 'artist', params:{ id : artist.uuid }}">{{ artist.name_eng }} <span v-if="isNotLast(album.artists, index1)">, </span></router-link>
                                        </template>
                                    </template> -->
                                </p>
                            </div>
                        </div>
                    </swiper-slide>
                </template>

            </swiper>

        </div>
        <!-- Add Arrows -->
        <template v-if="data.data.length > 8">
            <div class="slider_nav_next" :class="'swiper-button-album-next'+data.id+'-'+data.order"></div>
            <div class="slider_nav_prev d-none" :class="'swiper-button-album-prev'+data.id+'-'+data.order"></div>
        </template>

    </div>
</template>
